import { PhotoSize } from './types';
import { TypographySize } from '../typography/types';

export const SIZES_MAP: Record<PhotoSize, number> = {
    xs: 20,
    s: 32,
    m: 40,
    l: 48,
    xl: 56,
    xxl: 64,
    xxxl: 72,
    xxxxl: 80,
};

export const TEXT_SIZES_MAP: Record<PhotoSize, TypographySize> = {
    xs: 'caption1',
    s: 'caption1',
    m: 'body1_short',
    l: 'body2_short',
    xl: 'subtitle1',
    xxl: 'subtitle1',
    xxxl: 'subtitle1',
    xxxxl: 'subtitle1',
};
